import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { assertCapabilityNotInQuery } from "@wayfind/core";
import { App } from "./App";
import { Boundary } from "./components/Boundary";
import "./styles.css";

// This console mints capabilities all day. One regex, in production too,
// standing between a refactor and a publish capability ending up in a
// CDN log — the fragment is the half browsers do not transmit.
assertCapabilityNotInQuery(location.href);

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root.");

createRoot(root).render(
  <StrictMode>
    {/*
      Outside <App />, so a throw during the console's own mount is caught
      too — a boundary inside the thing that might fail to mount is not a
      boundary.
    */}
    <Boundary>
      <App />
    </Boundary>
  </StrictMode>
);
